import Constants from 'expo-constants';

export default { 
//Dev EPs
	OldAuthProvider: Constants.manifest.extra.OldAuthProvider,
	CapPayV2Link: Constants.manifest.extra.CapPayV2Link,
	PaymentGateway: Constants.manifest.extra.PaymentGateway,
}

